import api from './index'

export default function fetchGyms(params) {
  return api.get(`/api/gyms`, { params })
}
